import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { saveAs } from 'file-saver';
import { ConstantsFordProtect } from '../../../models/constants/constants-ford-protect';
import { InvoiceReportNoValueNotesResult } from '../../../models/Invoice/invoice-report-no-value-notes-result';
import { InvoiceReportSummaryResult } from '../../../models/Invoice/invoice-report-summary-result';
import { InvoiceReportValueNotesResult } from '../../../models/Invoice/invoice-report-value-notes-result';
import { InvoiceService } from '../../../services/invoice/invoice.service';
import { createWorkbookBuffer } from '../../../../assets/functions/exceljs-export';

type SelectOption<T = string | number> = { label: string; value?: T };
type ValueChangeEvent<T> = { value: T };

@Component({
    selector: 'app-reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.scss'],
    standalone: false
})
export class ReportsComponent implements OnInit {

  listCountries: SelectOption<string>[] = [
    { label: 'TRANSLATE.CHOOSE.COUNTRY.ARG', value: ConstantsFordProtect.ARG },
    { label: 'TRANSLATE.CHOOSE.COUNTRY.BRA', value: ConstantsFordProtect.BRA },
    { label: 'TRANSLATE.CHOOSE.COUNTRY.CHL', value: ConstantsFordProtect.CHL },
    { label: 'TRANSLATE.CHOOSE.COUNTRY.COL', value: ConstantsFordProtect.COL }
  ];

  listReportType: SelectOption<string>[] = [
    { label: 'TRANSLATE.INVOICE', value: ConstantsFordProtect.INVOICE }
  ];

  listMonths: SelectOption<string>[] = [
    { label: 'TRANSLATE.MONTH.JANUARY.UPPER.CASE', value: ConstantsFordProtect.JANUARY },
    { label: 'TRANSLATE.MONTH.FEBRUARY.UPPER.CASE', value: ConstantsFordProtect.FEBRUARY },
    { label: 'TRANSLATE.MONTH.MARCH.UPPER.CASE', value: ConstantsFordProtect.MARCH },
    { label: 'TRANSLATE.MONTH.APRIL.UPPER.CASE', value: ConstantsFordProtect.APRIL },
    { label: 'TRANSLATE.MONTH.MAY.UPPER.CASE', value: ConstantsFordProtect.MAY },
    { label: 'TRANSLATE.MONTH.JUNE.UPPER.CASE', value: ConstantsFordProtect.JUNE },
    { label: 'TRANSLATE.MONTH.JULY.UPPER.CASE', value: ConstantsFordProtect.JULY },
    { label: 'TRANSLATE.MONTH.AUGUST.UPPER.CASE', value: ConstantsFordProtect.AUGUST },
    { label: 'TRANSLATE.MONTH.SEPTEMBER.UPPER.CASE', value: ConstantsFordProtect.SEPTEMBER },
    { label: 'TRANSLATE.MONTH.OCTOBER.UPPER.CASE', value: ConstantsFordProtect.OCTOBER },
    { label: 'TRANSLATE.MONTH.NOVEMBER.UPPER.CASE', value: ConstantsFordProtect.NOVEMBER },
    { label: 'TRANSLATE.MONTH.DECEMBER.UPPER.CASE', value: ConstantsFordProtect.DECEMBER }
  ];

  listYear: SelectOption<number>[] = [
    { label: '2024', value: 2024 },
    { label: '2025', value: 2025 },
    { label: '2026', value: 2026 },
    { label: '2027', value: 2027 }
  ];

  userform!: UntypedFormGroup;
  selectedCountry!: string | undefined;
  selectedReportType!: string | undefined;
  selectedMonth!: string | undefined;
  selectedYear!: number | undefined;
  countryBRA = ConstantsFordProtect.BRA;
  invoice = ConstantsFordProtect.INVOICE;

  // new

  summary: InvoiceReportSummaryResult[] = [];
  valueNotes: InvoiceReportValueNotesResult[] = [];
  noValueNotes: InvoiceReportNoValueNotesResult[] = [];
  blockedUi = false;
  // errorStatus: any = 0;
  errorStatus = 0;

  constructor(
    private fb: UntypedFormBuilder,
    private messageService: MessageService,
    private translateService: TranslateService,
    private invoiceService: InvoiceService,
    private router: Router
  ) { }

  ngOnInit() {

    this.userform = this.fb.group({
      'optionCountry': [null, Validators.required],
      'optionReportType': [null, Validators.required],
      'optionMonth': [null, Validators.required],
      'optionYear': [null, Validators.required]
    });
  }

  countryChange(event: ValueChangeEvent<string | undefined>) {

    this.selectedCountry = event.value;
  }

  reportTypeChange(event: ValueChangeEvent<string | undefined>) {

    this.selectedReportType = event.value;
  }

  monthChange(event: ValueChangeEvent<string | undefined>) {

    this.selectedMonth = event.value;
  }

  yearChange(event: ValueChangeEvent<number | undefined>) {

    this.selectedYear = event.value;
  }

  buttonClean() {
    this.selectedCountry = undefined;
    this.selectedReportType = undefined;
    this.selectedMonth = undefined;
    this.selectedYear = undefined;
    this.userform.reset();
  }

  get isBrazilSelected(): boolean {
    return this.selectedCountry === this.countryBRA;
  }

  get canExport(): boolean {
    return this.isBrazilSelected
      && this.selectedReportType === this.invoice
      && !!this.selectedMonth
      && !!this.selectedYear;
  }

  async exportExcel() {

    if (this.selectedCountry !== ConstantsFordProtect.BRA && this.selectedCountry !== undefined && this.selectedCountry !== null) {

      this.messageService.add({
        severity: 'error',
        summary: this.translateService.instant('TRANSLATE.ERROR'),
        detail: this.translateService.instant('TRANSLATE.CURRENTLY.NO.REPORTS.COUNTRY')
      });

    } else if (this.userform.invalid) {

      if (this.selectedCountry === undefined || this.selectedCountry === null) {
        this.userform.get('optionCountry')?.markAsTouched();
        this.selectedCountry = undefined;
      }
      else if (this.selectedReportType === undefined || this.selectedReportType === null) {
        this.userform.get('optionReportType')?.markAsTouched();
        this.selectedReportType = undefined;
      }
      else if (this.selectedMonth === undefined || this.selectedMonth === null) {

        this.userform.get('optionMonth')?.markAsTouched();
        this.selectedMonth = undefined;
      }
      else if (this.selectedYear === undefined || this.selectedYear === null) {
        this.userform.get('optionYear')?.markAsTouched();
        this.selectedYear = undefined;
      }

    } else if (this.userform.valid) {

      this.blockedUi = true;

      // aba 1: resumo
      await this.invoiceService.invoiceReportSummaryPromise(this.selectedYear!.toString(), this.selectedMonth!.toString())
        .then((response: InvoiceReportSummaryResult[]) => {

          this.summary = response;
          this.blockedUi = false;

        }, (err) => {
          this.errorStatus = err.status;
        });

      // aba 2: notas com valor
      await this.invoiceService.invoiceReportValueNotesPromise(this.selectedYear!.toString(), this.selectedMonth!.toString())
        .then((response: InvoiceReportValueNotesResult[]) => {

          this.valueNotes = response;
          this.blockedUi = false;

        }, (err) => {
          this.errorStatus = err.status;
        });

      // aba 3: notas sem valor
      await this.invoiceService.invoiceReportNoValueNotesPromise(this.selectedYear!.toString(), this.selectedMonth!.toString())
        .then((response: InvoiceReportNoValueNotesResult[]) => {

          this.noValueNotes = response;
          this.blockedUi = false;

        }, (err) => {
          this.errorStatus = err.status;
        });

      if (this.errorStatus > 0) {

        if (this.errorStatus === 400 || this.errorStatus === 404 || this.errorStatus === 500) {

          this.messageService.add({
            severity: 'error', summary: this.translateService.instant('TRANSLATE.ERROR'),
            detail: this.translateService.instant('TRANSLATE.EXCEL.CANNOT.BE.EXPORTED')
          });

        } else if (this.errorStatus === 401) {

          this.messageService.add({
            severity: 'error',
            summary: this.translateService.instant('TRANSLATE.ERROR'),
            detail: this.translateService.instant('TRANSLATE.USER.WITHOUT.PERMISSION.REFRESH.PAGE')
          });

        } else {

          this.messageService.add({
            severity: 'error',
            summary: this.translateService.instant('TRANSLATE.ERROR'),
            detail: this.translateService.instant('TRANSLATE.ERROR.CONTACT.SYSTEM.ADMINISTRATOR')
          });
        }
      } else {
        this.importXlsxMultiTabFromArray(this.summary, this.valueNotes, this.noValueNotes);

        this.messageService.add({
          severity: 'success',
          summary: this.translateService.instant('TRANSLATE.SUCCESS'),
          detail: this.translateService.instant('TRANSLATE.REPORT.GENERATED.SUCCESSFULLY')
        });
        this.router.navigate(['home'], { skipLocationChange: false, replaceUrl: false });
      }

      this.blockedUi = false;

    } else {

      this.messageService.add({
        severity: 'error',
        summary: this.translateService.instant('TRANSLATE.ERROR'),
        detail: this.translateService.instant('TRANSLATE.ERROR.PLEASE.REQUIRED.FIELDS')
      });
    }
  }


  private importXlsxMultiTabFromArray(summary: InvoiceReportSummaryResult[]
    , valueNotes: InvoiceReportValueNotesResult[]
    , noValueNotes: InvoiceReportNoValueNotesResult[]): void {
    void createWorkbookBuffer([
      {
        name: 'Resumo',
        rows: summary as unknown as Record<string, unknown>[],
        cells: {
          C10: 'TOTAL ',
          D10: { formula: 'SUM(D2:D8)' },
          E10: { formula: 'SUM(E2:E8)' },
          F10: { formula: 'SUM(F2:F8)' }
        }
      },
      {
        name: 'Notas com valor',
        rows: valueNotes as unknown as Record<string, unknown>[]
      },
      {
        name: 'Notas sem valores',
        rows: noValueNotes as unknown as Record<string, unknown>[]
      }
    ])
      .then(excelBuffer => {
        this.saveAsExcelFile(excelBuffer, 'invoices');
      });
  }

  private saveAsExcelFile(buffer: BlobPart, fileName: string): void {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    saveAs(data, fileName + EXCEL_EXTENSION);
  }

}